module.exports = __webpack_public_path__ + "static/img/1.2b4c2a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yxsc/1.png
// module id = 1eKH
// module chunks = 1